import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nrkKeyValue'
})
// keyvalue pipe without sorted keys
export class NrkKeyValuePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value || typeof value !== 'object') {
      return [];
    }
    const ret = Object.keys(value).map(key => ({ key, value: value[key] }));  
    return ret;
  }
}
